import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';

export type GanasocioInvitationConflictVariant = 'already-registered' | 'duplicate-ganasocio' | 'duplicate-other-type';

export type GanasocioInvitationConflictAction =
  | 'add-new-referral'
  | 'back'
  | 'see-invitation'
  | 'cancel-invitation'
  | 'keep-invitation';

export interface IGanasocioInvitationConflictModalData {
  variant: GanasocioInvitationConflictVariant;
  invitedUserTypeName?: string;
}

@Component({
  selector: 'app-ganasocio-invitation-conflict-modal',
  imports: [KorviuButtonComponent, TranslatePipe],
  templateUrl: './ganasocio-invitation-conflict-modal.component.html',
  styleUrl: './ganasocio-invitation-conflict-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GanasocioInvitationConflictModalComponent {
  readonly data = inject<IGanasocioInvitationConflictModalData>(NZ_MODAL_DATA);
  readonly #modal = inject(NzModalRef<GanasocioInvitationConflictModalComponent>);

  public close(action?: GanasocioInvitationConflictAction): void {
    this.#modal.close(action);
  }
}
